var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImmoweb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1200px",
    height: "182px",
    viewBox: "0 0 158 24",
    style: {
      enableBackground: "new 0 0 158 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3D6CA9;}\n\t.st1{fill:#65D78D;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.4,0.9V23H0V0.9H6.4z M19.4,0.9l2.3,7.2c0.3,0.8,0.5,1.7,0.8,2.5c0.2,0.7,0.4,1.5,0.7,2.2 c0.2-0.7,0.4-1.3,0.6-2c0.3-0.9,0.6-1.8,0.8-2.7L27,0.8h6.8l3.5,22.1H31L30,15c-0.2-1.7-0.4-3.3-0.6-4.9l-1.2,3.6L25,23.1h-3.8 L18,13.9l-1.2-3.6c-0.2,1.7-0.4,3.4-0.6,5.2l-1,7.6H8.9L12.5,1h6.9V0.9z M49.3,0.9l2.3,7.2c0.3,0.8,0.5,1.7,0.8,2.5 c0.2,0.7,0.4,1.5,0.7,2.2c0.2-0.7,0.4-1.3,0.6-2C54,9.9,54.3,9,54.5,8.1L57,0.9h6.8L67.3,23h-6.4l-1-7.9c-0.2-1.7-0.4-3.3-0.6-4.9 l-1.2,3.6L54.9,23h-3.8L48,13.8l-1.2-3.6c-0.2,1.7-0.4,3.4-0.6,5.2l-1,7.6h-6.4l3.6-22.1C42.4,0.9,49.3,0.9,49.3,0.9z M87.8,2.6 c1.5,1.2,4.4,4,4.4,9.1c0,1.3-0.3,4.9-2.9,7.9c-1.5,1.7-4.4,3.9-9.6,3.9c-4.7,0-7.5-1.9-8.8-3.4c-1.1-1.2-3-4-3-8.2 c0-1.4,0.3-5.3,3.3-8.3c3.3-3.3,7.7-3.3,9.1-3.3C83.1,0.4,85.5,0.9,87.8,2.6z M77.6,6.2c-1.4,0.7-3.3,2.2-3.3,5.9 c0,0.4,0,1.5,0.4,2.7c0.8,2.3,2.8,3.7,5.3,3.7c1.5,0,3.1-0.5,4.2-1.7c1.2-1.3,1.6-3.2,1.6-4.9c0-3.7-2.1-5.4-3.5-5.9 c-0.8-0.3-2-0.3-2-0.3S78.7,5.6,77.6,6.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.4,23.1H111l-3.7-12.6l-3.6,12.6h-5.4L91.3,1h5.8l4.1,13.5L105.1,1h4.5l3.9,13.5l4-13.5h5.8L116.4,23.1z  M137.9,0.9v5.2h-7v3.2h6.1v5.2h-6.1v3.4h7.3V23h-13.3V0.9H137.9z M148.1,0.9c2.7,0,6.1,0.1,7.5,3c0.3,0.5,0.6,1.4,0.6,2.7 c0,0.8-0.1,2.6-1.8,4c-0.3,0.3-0.8,0.6-0.9,0.6c0.6,0.2,1.2,0.5,1.7,0.8c2.3,1.5,2.4,4.1,2.4,4.9c0,0.5,0,1.8-0.8,3.1 c-1.7,2.9-5.8,2.9-9.2,3h-7.1V0.9H148.1z M146.7,9.6h1.2c0.3,0,1.6,0.1,2.3-0.9c0.2-0.3,0.3-0.8,0.3-1.2c0-0.1,0-0.5-0.1-0.8 c-0.5-1.3-2.2-1.3-2.4-1.3h-1.3V9.6z M146.7,18.6h1.9c0.9,0,2-0.1,2.6-0.9c0.3-0.5,0.4-1.1,0.4-1.3c0-0.5-0.1-0.8-0.2-1 c-0.5-1.1-1.6-1.2-2.6-1.3h-2L146.7,18.6L146.7,18.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImmoweb);
export default __webpack_public_path__ + "static/media/immoweb.6e4f31e5ad3f8e00d15ca87f6ce550b7.svg";
export { ForwardRef as ReactComponent };